<template>
    <div class="modal" id="login-modal" tabindex="-1" aria-labelledby="login-modal" aria-hidden="true" ref="modal">
        <div class="modal-dialog">
            <div class="modal-content ">
                <div class="modal-header">
                    <h5 class="modal-title">Login</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="login-modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form action="javascript:void(0)">
                        <!--
                        <input type="text" class="form-control mt-2" name="username" placeholder="user@domain.com" v-model="username" />
                        <input type="password" class="form-control mt-2" name="password" placeholder="password" v-model="password" />
                        <div class="d-flex justify-content-around my-3">
                            <button type="submit" class="btn btn-primary w-auto" @click="submit"><i class="fas fa-sign-in-alt"></i>&nbsp;Login</button>
                            <button type="button" class="btn btn-primary w-auto" @click="create"><i class="fas fa-user-plus"></i>&nbsp;Create Account</button>
                        </div>
                        
                        <hr class="text-dark">
                    -->
                        
                        <div class="d-flex justify-content-center">
                            <div class="d-flex flex-column justify-content-center my-3">
                                <div id="google-button" class="oauth-button d-flex border border-secondary px-3 py-2 align-content-center text-nowrap pe-pointer bg-light mb-3" @click="googleLogin">
                                    <img src="/img/Google-Logo.svg" alt="Google" class="me-2"><span>Sign in with Google</span>
                                </div>

                                <div id="microsoft-button" class="oauth-button d-flex border border-secondary px-3 py-2 align-content-center text-nowrap pe-pointer bg-light" @click="microsoftLogin">
                                    <img src="/img/MS-Logo.svg" alt="MS" class="me-2"><span>Sign in with Microsoft</span>
                                </div>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    mounted() {
        this.modal = new bootstrap.Modal(this.$refs.modal);
        this.eventHub.$on('loginPressed', event => {
            this.modal.show();
        });
    },

    methods: {
        submit() {
            const data = {
                email: this.username,
                password: this.password
            };
            
            axios
                .post('/api/user/login', data)
                .then(response => {
                    if (response.data.status) {
                        location.reload();
                        this.eventHub.$emit('user-login', response.data);
                    } else {
                        console.log(window);
                        let data = {
                            'body': 'Login Failed.',
                            'heading': '<i class="fas fa-exclamation-triangle text-warning"></i> Could not verify your credentials',
                        };
                        this.eventHub.$emit('toast_add', data);


                    }
                })
                .catch( error => {
                    console.error(error);
                });

        },

        create() {
            window.location.assign('/user');
        },

        googleLogin() {
            window.location.assign(`/auth/redirect/google?origin=${ window.location.pathname }`);
        },

        microsoftLogin() {
            window.location.assign(`/auth/redirect/microsoft?origin=${ window.location.pathname }`);
        },
    },


    data() {
        return {
            username: '',
            password: '',
        }
    }

}
</script>

<style scoped>
    .oauth-button {
        height: 41px;
    }

    .oauth-button:hover {
        /* border-color: aqua !important; */
        background-color: #dee2e6 !important;
    }

    .oauth-button:active {
        border-color: orange !important;
    }

    #google-button {
        font-family: "Roboto", sans-serif;
        font-weight: 500;
        font-style: normal;
    }

    #microsoft-button {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, 'Noto Sans', sans-serif;
        font-weight: 600;
        font-style: normal;
    }
</style>